import { SwitchLabel, SwitchSlider } from "@/components/Switch";
import Text from "@/components/Text";
import { FC } from "react";
import styled from "styled-components";

const Box = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  padding: 16px;
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayscale};
`;

interface Props {
  hasFirstComment: boolean;
  setHasFirstComment: React.Dispatch<React.SetStateAction<boolean>>;
}

const FirstCommentBox: FC<Props> = ({
  hasFirstComment,
  setHasFirstComment,
}) => {
  return (
    <Box>
      <TopRow>
        <Text $type="smallBold">First Comment</Text>
        <SwitchLabel>
          <input
            type="checkbox"
            checked={hasFirstComment}
            onChange={() => setHasFirstComment((prev) => !prev)}
          />
          <SwitchSlider $disabled={false} />
        </SwitchLabel>
      </TopRow>
      <Text $color="gray" $type="smallNormal">
        Add the initial comment message, which will be immediately posted once
        the post is added
      </Text>
    </Box>
  );
};

export default FirstCommentBox;
